import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWarningSign: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="warning-sign,attention,coution"><path d="M2.75 20.25L6.75 3.75H17.25L21.25 20.25M13.25 20.25L17.03 4.65754M4 16.75H20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconWarningSign;
